module.exports = __webpack_public_path__ + "img/svg/verified.bc222998ab30a3c685ed44e7a317e13e.svg";